import React from 'react';
import PageLoader from './PageLoader';

/**
 * Loader — Full page loader used for React Suspense / lazy loading.
 * Delegates to PageLoader for consistent CaCart branding.
 */
const Loader = ({ height, ...props }: { height?: string }) => (
  <PageLoader height={height || "100vh"} message="Loading..." />
);

Loader.defaultProps = {
  height: '100vh',
};

export default Loader;
